module.exports = __webpack_public_path__ + "img/LOGO FIX PNG 1.fb630d2b.svg";